import { post, get } from '../../../components/hooks/apiFetch';

export const useDepersonalizeFileDataApi = () => {
    const submitDepersonalizeFileDataRequest = async (filesWithFormats, comment = '', startTime = '') => {
        comment ??= '';
        const formData = new FormData();
        filesWithFormats.forEach((item, index) => {
            formData.append(`Files[${index}].File`, item.file, item.file.name);
            formData.append(`Files[${index}].OutputFormat`, item.outputFormat);
            if (item.templateName && item.templateName.trim() !== '') {
                formData.append(`Files[${index}].TemplateName`, item.templateName);
            }
        });

        formData.append("Options.Comment", comment.trim());
        formData.append("Options.StartTime", startTime);

        const result = await post("/api/depersonalizefiledata", formData);

        return {
            id: result.id,
            identifier: result.identifier
        };
    };

    const cancelDepersonalizeFileDataTask = async (inputIdentifier) => {
        await get(`/api/depersonalizefiledata/cancel/${encodeURIComponent(inputIdentifier)}`);
        return true;
    };

    return { submitDepersonalizeFileDataRequest, cancelDepersonalizeFileDataTask };
};